<template>
  <div class="certificate-detail bgf6">
    <div class="certificate-content">
      <img class="img-bg" src="../../static/images/certificate/bg_zsbg@2x.png" alt="" srcset="">
      <div class="certificate-container">
        <div class="icm-left">
          <div class="icm-office">
            <img :src="data.officialPhoto2" alt="">
          </div>
          <div class="icm-item" style="margin-top: .68rem">
            <div class="icm-top">
              <div class="icm-label">
                <div class="title">证书编号:</div>
              </div>
              <div class="icm-value">{{data.evaluateCertificateNo}}</div>
            </div>
            <div class="icm-tips">NO:</div>
          </div>
          <div class="icm-row">
            <div class="icm-col" style="width: 40%">
              <div class="icm-item">
                <div class="icm-top">
                  <div class="icm-label">
                    <div class="title">考级专业:</div>
                  </div>
                  <div class="icm-value">{{data.specialtyName}}</div>
                </div>
                <div class="icm-tips">SPECLALITY:</div>
              </div>
            </div>
            <div class="icm-col" style="width: 60%">
              <div class="icm-item">
                <div class="icm-top">
                  <div class="icm-label">
                    <div class="title">起止级:</div>
                  </div>
                  <div class="icm-value">一至九级</div>
                </div>
                <div class="icm-tips">GRADE OF BEGINNING&END:</div>
              </div>
            </div>
          </div>
          <div class="icm-row">
            <div class="icm-col" style="width: 40%">
              <div class="icm-item">
                <div class="icm-top">
                  <div class="icm-label">
                    <div class="title">等级:</div>
                  </div>
                  <div class="icm-value">{{data.gradeName}}</div>
                </div>
                <div class="icm-tips">GRADE:</div>
              </div>
            </div>
            <div class="icm-col" style="width: 60%">
              <div class="icm-item">
                <div class="icm-top">
                  <div class="icm-label">
                    <div class="title">发证时间:</div>
                  </div>
                  <div class="icm-value">{{$moment(data.publishTime).format('YYYY.MM.DD')}}</div>
                </div>
                <div class="icm-tips">DATE OF ISSUE:</div>
              </div>
            </div>
          </div>
        </div>
        <div class="icm-right">
          <div class="icm-item" style="margin-top: 2.13rem">
            <div class="icm-top">
              <div class="icm-label">
                <div class="title">姓名:</div>
              </div>
              <div class="icm-value">{{data.examineeName}}</div>
            </div>
            <div class="icm-tips">NAME:</div>
          </div>
          <div class="icm-item">
            <div class="icm-top">
              <div class="icm-label">
                <div class="title">性别:</div>
              </div>
              <div class="icm-value">{{$enums.sex[data.examineeSex]}}</div>
            </div>
            <div class="icm-tips">SEX:</div>
          </div>
          <div class="icm-item">
            <div class="icm-top">
              <div class="icm-label">
                <div class="title">出生日期:</div>
              </div>
              <div class="icm-value">{{data.birthday}}</div>
            </div>
            <div class="icm-tips">DATE OF BRITH:</div>
          </div>
          <div class="icm-item">
            <div class="icm-top">
              <div class="icm-label">
                <div class="title">民族:</div>
              </div>
              <div class="icm-value">{{data.nationality}}</div>
            </div>
            <div class="icm-tips">NATION:</div>
          </div>
          <div class="icm-item">
            <div class="icm-top">
              <div class="icm-label">
                <div class="title">国籍:</div>
              </div>
              <div class="icm-value">{{data.country}}</div>
            </div>
            <div class="icm-tips">NATIONALITY:</div>
          </div>
          <div class="icm-item">
            <div class="icm-top">
              <div class="icm-label">
                <div class="title">主任:</div>
                <div class="icm-tips">DIRECTOR:</div>
              </div>
              <div class="icm-value">
                <img style="width: 1.57rem; height: 1.44rem" src="../../static/images/certificate/img_sign.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="icm-seal">
        <div class="seal-img">
          <img src="../../static/images/certificate/img-seal.png" alt="" srcset="">
          <div class="seal-tips">故宫博物院</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Picker, Popup, Icon, PullRefresh, List, Empty } from 'vant'

export default {
  name: 'certificate-detail',
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
  },
  data () {
    return {
      evaluateExamId: '',
      data: {}
    }
  },
  async created () {
    this.evaluateExamId = this.$route.query.evaluateExamId
    this.getresultDetail(this.evaluateExamId)
  },
  methods: {
    async getresultDetail (evaluateExamId) {
      let { data } = (await this.$HTTP.ApiExamResult.getresultDetail(evaluateExamId)) || {}
      this.data = data || {}
      if (this.data.evaluateSign) {
        let evaluateSigns = this.data.evaluateSign.split(',')
        this.$set(this.data, 'evaluateSign1', evaluateSigns[0])
      } else {
        this.$set(this.data, 'evaluateSign1', '')
      }
      let officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(
        data.officialPhoto,
        "ID-photo"
      )
      this.$set(this.data, 'officialPhoto2', officialPhoto2)
      
    }
  }
}
</script>
<style lang="less" scoped>
  .certificate-detail {
    transform: rotate(90deg);
  }
  
  .certificate-content {
    position: relative;
    margin-top: 80px/2;
    height: calc(100vw - 40px);
    width: calc(155vw - 60px);
    .img-bg {
      height: calc(100vw - 40px);
      width: calc(155vw - 60px);
    }

    .certificate-container {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      .icm-left {
        width: 60%;
        padding-left: 74/2px;
        .icm-office {
          text-align: center;
          margin-top: 100px;
          img {
            height: 154px/2;
            width: 110px/2;
          }
        }
      }
      icm-right {
        width: 40%;
      }
    }

    .icm-item {
      font-size: 18px/2;
      margin-top: 15px;
      line-height: 20px/2;
      .icm-top {
        display: flex;
        .icm-label {
          width: 90px/2;
          flex-shrink: 0;
        }
        .icm-value {
          vertical-align: middle;
          color:#BC3019;
        }
      }
      .icm-tips {
        font-size: 16px/2;
        color: #221E1F;
        font-family: 'SourceHanSerifCN-Regular'
      }
    }

    .icm-row {
      display: flex;
    }
  }

  .icm-seal {
    position: absolute;
    right: 79px/2;
    bottom: 56px/2;

    .seal-img {
      width: 142px/2;
      height: 142px/2;
      img {
        width: 142px/2;
        height: 142px/2;
      }
      .seal-tips {
        position: absolute;
        bottom: 28px/2;
        right: 18px/2;
        font-size: 14px/2;
        color: #221E1F;
        font-family: 'SourceHanSerifCN-Medium';
      }
    }
  }
  
</style>
